export default "__VITE_ASSET__M6GMo4f1__"